import get from 'lodash/get'

import {
  fetchCollection
} from './index'

import { workTrackerSchema } from '../schemas'

export const WORK_TRACKERS_REQUEST = 'WORK_TRACKERS_REQUEST'
export const WORK_TRACKERS_SUCCESS = 'WORK_TRACKERS_SUCCESS'
export const WORK_TRACKERS_FAILURE = 'WORK_TRACKERS_FAILURE'

export function fetchWorkTrackersForLocation (locationId, rest) {
  return fetchCollection({
    url: `/locations/${locationId}/work_trackers`,
    key: 'contractWorkTrackers',
    actions: [WORK_TRACKERS_REQUEST, WORK_TRACKERS_SUCCESS, WORK_TRACKERS_FAILURE],
    schema: workTrackerSchema,
    responseInterceptor: response => ({ ...response, locationId }),
    ...rest
  })
}

export function fetchWorkTrackersForLocationWithFilters (locationId) {
  return (dispatch, getState) => {
    const {
      contractId,
      areaTypeId
    } = get(getState(), `workTrackerFilters.${locationId}`, {})

    return dispatch(
      fetchWorkTrackersForLocation(locationId, { query: { contractId, areaTypeId } })
    )
  }
}

export const AREA_WORK_TRACKERS_REQUEST = 'AREA_WORK_TRACKERS_REQUEST'
export const AREA_WORK_TRACKERS_SUCCESS = 'AREA_WORK_TRACKERS_SUCCESS'
export const AREA_WORK_TRACKERS_FAILURE = 'AREA_WORK_TRACKERS_FAILURE'

export function fetchWorkTrackersForArea (areaId) {
  return fetchCollection({
    url: `/areas/${areaId}/work_trackers`,
    key: 'areaWorkTrackers',
    actions: [AREA_WORK_TRACKERS_REQUEST, AREA_WORK_TRACKERS_SUCCESS, AREA_WORK_TRACKERS_FAILURE],
    schema: workTrackerSchema,
    responseInterceptor: response => ({ ...response, areaId })
  })
}



// WEBPACK FOOTER //
// ./src/actions/work-trackers.js